import type { SortingState } from '@ovComponents/2-component/dataTable';

export const PORTFOLIO_SORT_FIELD_BY_COLUMN_ID = {
  value: 'marketValueCents',
  trades: 'pendingSubTradeRequests',
  lastRebalDate: 'lastOptimizedBy',
} as const;

export type SortablePortfolioColumnId =
  keyof typeof PORTFOLIO_SORT_FIELD_BY_COLUMN_ID;

export const DEFAULT_PORTFOLIO_SORT_FIELD = 'updatedAt';
export const DEFAULT_PORTFOLIO_SORT_DESC = true;

export type PortfolioSortVariables = {
  sortField: string;
  sortDesc: boolean;
};

export const isSortablePortfolioColumn = (
  columnId: string,
): columnId is SortablePortfolioColumnId =>
  Object.hasOwn(PORTFOLIO_SORT_FIELD_BY_COLUMN_ID, columnId);

export const getPortfolioSortVariables = (
  sorting: SortingState,
): PortfolioSortVariables => {
  const [activeSort] = sorting;

  if (!activeSort || !isSortablePortfolioColumn(activeSort.id)) {
    return {
      sortField: DEFAULT_PORTFOLIO_SORT_FIELD,
      sortDesc: DEFAULT_PORTFOLIO_SORT_DESC,
    };
  }

  return {
    sortField: PORTFOLIO_SORT_FIELD_BY_COLUMN_ID[activeSort.id],
    sortDesc: activeSort.desc,
  };
};
